import { trackingPageSettingsSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getTrackingPage = {
  name: "getTrackingPage" as const,
  input: z.object({}),
  output: z.object({
    trackingPage: z
      .object({
        id: zExt.objectId(),
        teamId: zExt.objectId(),
        settings: trackingPageSettingsSchema,
        createdAt: z.string(),
        updatedAt: z.string(),
      })
      .nullable(),
    success: z.boolean(),
  }),
};
